import React from 'react';
import {useSelector} from 'react-redux';
import {twMerge} from 'tailwind-merge';

import appConfig from '../../config/appConfig';
import * as localizationKeys from '../../consts/localization/localizationKeys';
import analyticsService from '../../services/analyticsService';
import {selectIotDeviceCodentify, selectIotDeviceType} from '../../state/selectors/iotDevice';
import {Article} from '../DataDisplay';
import ManualActivationIcon from '../Icons/ManualActivationIcon';
import ContentWrapper from '../Layout/ContentWrapper';

const ManualActivation = () => {
    const deviceCodentify = useSelector(selectIotDeviceCodentify);
    const manualActivationUrl = appConfig.getManualActivationUrlFormatted(deviceCodentify);
    const deviceType = useSelector(selectIotDeviceType);

    if (!manualActivationUrl) {
        return null;
    }

    return (
        <div className='mt-[60px] w-full'>
            <ContentWrapper>
                <Article
                    icon={<ManualActivationIcon className='h-12 w-12' />}
                    className='w-full'
                    titleKey={localizationKeys.ERROR_POPUP_OTHER_WAY_CONNECT_MANUAL_ACTIVATION}
                    titleClassName={twMerge('text-18 mt-3 md:mt-4')}
                    descriptionKey={localizationKeys.ERROR_POPUP_OTHER_WAY_MANUAL_ACTIVATION_DESCRIPTION_NAMED}
                    buttonSecondary={{
                        isExternalLink: true,
                        onClick: () => analyticsService.pushActivationFlowContinueManualEvent(deviceType),
                        to: manualActivationUrl,
                        className: 'mt-6 sm:min-w-[312px]',
                        textKey: localizationKeys.ERROR_POPUP_OTHER_WAY_MANUAL_ACTIVATION_BUTTON_TEXT,
                    }}
                />
            </ContentWrapper>
        </div>
    );
};

export default ManualActivation;
